import { render, staticRenderFns } from "./DedicateModal.vue?vue&type=template&id=2f67cbd4&"
import script from "./DedicateModal.vue?vue&type=script&lang=js&"
export * from "./DedicateModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports